import { PlusOutlineIcon } from '@carboncopyco/icons';
import type { Workspace } from '@carboncopyco/types';
import {
  Button,
  Container,
  Grid,
  NavigationCard,
  SkeletonRowLoading,
  TooltipBubble,
  notify,
} from '@carboncopyco/ui';
import { capitalize } from '@carboncopyco/utils';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { InfiniteList } from '../../InfiniteList';
import { WorkspaceAvatar } from '../WorkspaceAvatar';
import { WorkspacesPageArchivedTileActions } from './WorkspacesPageArchivedTileActions';
import { useWorkspacesPage } from './WorkspacesPageContext';
import { WorkspacesPageEmpty } from './WorkspacesPageEmpty';
import { WorkspacesPageTileActions } from './WorkspacesPageTileActions';

export const WorkspacesPageGrid = () => {
  const {
    workspaces,
    isLoading,
    getWorkspaceLink,
    joinWorkspace,
    organizationId,
    replaceItem,
    handleFetchNextBatch,
    isLoadingBatch,
  } = useWorkspacesPage();

  const isEmpty = !isLoading && workspaces?.length < 1;
  const [isMenuOpen] = useState(false);

  return (
    <div className="w-full h-full overflow-y-hidden">
      {isEmpty ? (
        <WorkspacesPageEmpty />
      ) : (
        <InfiniteList
          isLoading={isLoading}
          isLoadingBatch={isLoadingBatch}
          loader={
            <Container>
              <SkeletonRowLoading itemsCount={10} />
            </Container>
          }
          onReachBottom={() => {
            console.log('reache∂ bottom');
            handleFetchNextBatch();
          }}
        >
          <Grid<Workspace>
            cols={3}
            data={workspaces}
            renderItem={(workspace) => (
              <NavigationCard
                containerClass="w-[366px]"
                key={workspace.id}
                as={Link}
                to={workspace.isMember && getWorkspaceLink(workspace.id)}
                title={workspace.workspaceName}
                description={capitalize(workspace.workspaceType)}
                isActionActive={isMenuOpen}
                actionOnHover={workspace.isMember}
                image={
                  <WorkspaceAvatar
                    workspace={workspace}
                    iconTooltip
                  />
                }
                action={
                  !workspace.isDeleted ? (
                    workspace.isMember ? (
                      <WorkspacesPageTileActions workspace={workspace} />
                    ) : (
                      <TooltipBubble
                        placement="top"
                        title="Join workspace"
                      >
                        <Button
                          aria-label="Join workspace"
                          icon={<PlusOutlineIcon />}
                          link
                          secondary
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();

                            joinWorkspace({
                              workspaceId: workspace.id,
                              organizationId,
                            })
                              .unwrap()
                              .then(() => {
                                notify.success('Joined workspace');
                                replaceItem(workspace.id, {
                                  ...workspace,
                                  isMember: true,
                                  totalMembers: workspace.totalMembers + 1,
                                });
                              })
                              .catch(() => {
                                notify.error('Failed to join workspace');
                              });
                          }}
                        />
                      </TooltipBubble>
                    )
                  ) : (
                    workspace.isMember && (
                      <WorkspacesPageArchivedTileActions
                        workspace={workspace}
                      />
                    )
                  )
                }
              />
            )}
          />
        </InfiniteList>
      )}
    </div>
  );
};
